import { FieldBuilderComponent } from './field-builder/fieldbuilderComponent';
import { DynamicFormBuilderComponent } from './dynamicFormBuilder';
import { TextBoxComponent } from './inputs/textbox';
import { DropDownComponent } from './inputs/dropDown';
import { PasswordComponent } from './inputs/password';
import { NumberComponent } from './inputs/number';
import { RadioComponent } from './inputs/radio';
import { CheckComponent } from './inputs/checkbox';
import { DateComponent } from './inputs/date';
import { MultipleDateComponent } from './inputs/multipleDate';
import { SingleSelectComponent } from './inputs/singleSelect';
import { MultiSelectComponent } from './inputs/multiSelect';
import { FileComponent } from './inputs/file';
import { from } from 'rxjs';
import { ButtonComponents } from './inputs/button';
import { DropDownNewComponent } from './inputs/drop_down';
import { TextareaComponent } from './inputs/textarea';
import { MapDropdownComponent } from './inputs/map_dropdown';
import { DynamicDropDownComponent } from './inputs/dynamicDropDown';
export const formPageDeclaration = [FieldBuilderComponent, TextBoxComponent,
    DynamicFormBuilderComponent, DropDownComponent, PasswordComponent,TextareaComponent,
    NumberComponent, RadioComponent, CheckComponent, DateComponent, MultipleDateComponent, ButtonComponents,
    SingleSelectComponent, MultiSelectComponent, FileComponent, DropDownNewComponent, MapDropdownComponent, DynamicDropDownComponent];
